import axios from 'axios';
import { API_URL } from '../config';

export async function fetchFromCacheById(id) {
  const URL = `${API_URL}/cache/${id}`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => response.data);
}

export async function saveRecurringPaymentInCacheAPI(data) {
  const {
    amount,
    contractId,
    email,
    emailConfirm,
    firstName,
    lastName,
    mobilePhone,
    isInsured,
    isPhoneDefault,
    isEmailDefault,
    type,
    payableSchedule,
    basket,
    attachCardAgreement,
  } = data;

  const URL = `${API_URL}/cache`;
  return axios.post(URL,
    {
      amount,
      contractId,
      email,
      emailConfirm,
      firstName,
      lastName,
      mobilePhone,
      isInsured,
      isPhoneDefault,
      isEmailDefault,
      type,
      payableSchedule,
      basket,
      attachCardAgreement,
    }).then((res) => res.data);
}
